import gql from "graphql-tag";

export const CONFIRM_CODE = gql`
  mutation ConfirmCode($code: String!, $email: String!) {
    confirmCode(code: $code, email: $email) {
      accessToken
    }
  }
`;
